<template>
	<div>
		<div class="single-container" >
			<img class="single-image" :src="itemChild.bookLogoUrl" alt="">
			<div class="single-description">
				<div class="single-top">
					<span class="single-title">{{itemChild.bookName}}</span>
				</div>
				<span class="single-brief">{{itemChild.bookSummary}}</span>
				<div class="single-bottom">
					<span class="single-author">{{itemChild.bookFinish===0?'完结':'连载'}} {{itemChild.bookNum}}万字</span>
				<span class="sort"  v-if="itemChild.category">{{itemChild.category.split(',')[0]}}</span>
					<!-- <span class="single-title-right">{{itemChild.studyingVolume}}万人在读</span> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default {
		name: 'uni-segmented-control',
		props: {
			itemChild: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
			};
		},
		watch: {
			// current(val) {
			// 	if (val !== this.currentIndex) {
			// 		this.currentIndex = val;
			// 	}
			// }
		},
		methods: {
			
		},
		created() {
		}
	};
</script>

<style  scoped>
	.single-container {
		display: flex;
		margin-top: 16px;
	}
	
	.single-image {
	width: 70px;
		height: 92px;
		border-radius: 6px;
	}
	.single-description {
		margin-left: 12px;
		  /* width: 85%; */
		width: 246px;
	}
	
	.single-top {
		margin-bottom: 6px;
	}
	
	.single-title {
		font-size: 15px;
		color: #333333;
		font-weight: bold;
	}
	
	.sort {
		background-color: rgb(253, 245, 233);
		border-radius: 2px;
		font-size: 12px;
		padding: 0px 5px;
		color: #F09B28;
		margin-left: 8px;
	}
	
	.single-brief {
		font-size: 14px;
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		color: #666666;
		line-height: 20px;
		width: 246px;
	}
	.single-bottom {
		display: flex;
		justify-content: space-between;
		margin-top: 11px;
	}
	.single-author {
		font-size:12px;
		color: #AAAAAA;
		width: 135px;
	}
	.single-title-right {
		font-size: 12px;
		color: #DE3B34;
	}
</style>



// WEBPACK FOOTER //
// src/view/components/list-itemone.vue